module.exports = __webpack_public_path__ + "static/media/image_15.68733667.jpg";